import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

const FEATURED = [
  { team1: 'Bulls',    team2: 'Lakers',    year: '1991 Finals' },
  { team1: 'Warriors', team2: 'Cavaliers', year: '2016 Finals' },
  { team1: 'Celtics',  team2: 'Lakers',    year: '1984 Finals' },
];

const TOP_PLAYERS = [
  { name: 'Michael Jordan',      ppg: 31.4, goat: 96.2, color: '#F5820A', pos: 'SG' },
  { name: 'LeBron James',        ppg: 28.7, goat: 93.8, color: '#7B8FD4', pos: 'SF' },
  { name: 'Kareem Abdul-Jabbar', ppg: 29.2, goat: 91.4, color: '#2ECC71', pos: 'C'  },
  { name: 'Magic Johnson',       ppg: 22.0, goat: 89.7, color: '#C9A84C', pos: 'PG' },
  { name: 'Bill Russell',        ppg: 15.1, goat: 88.9, color: '#E74C3C', pos: 'C'  },
];

const STATS = [
  { label: 'Players Indexed',  val: '15+'         },
  { label: 'Eras Covered',     val: '1946–2024'   },
  { label: 'Simulations Run',  val: '10K/query'   },
  { label: 'Model',            val: 'Claude Haiku' },
];

const Dashboard: React.FC = () => {
  const [simResults,  setSimResults]  = useState<Record<string, number>>({});
  const [simLoading,  setSimLoading]  = useState<string | null>(null);
  const [liveGames,   setLiveGames]   = useState<any[]>([]);
  const [liveLoading, setLiveLoading] = useState(true);
  const [liveDate,    setLiveDate]    = useState('');

  useEffect(() => {
    fetch(`${API_URL}/live`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({}) })
      .then(r => r.json())
      .then(d => {
        setLiveGames(d.games || []);
        setLiveDate(d.date   || '');
        setLiveLoading(false);
      })
      .catch(() => setLiveLoading(false));
  }, []);

  const quickSim = async (team1: string, team2: string, key: string) => {
    setSimLoading(key);
    try {
      const res  = await fetch(`${API_URL}/simulate`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ team1, team2, runs: 10000 })
      });
      const data = await res.json();
      setSimResults(prev => ({ ...prev, [key]: data.win_probability }));
    } catch {}
    finally { setSimLoading(null); }
  };

  return (
    <div style={{
      background: '#0D0F14', minHeight: 'calc(100vh - 48px)',
      color: '#F0EDE6', padding: '20px 24px', overflowY: 'auto'
    }}>

      {/* Welcome banner */}
      <div style={{
        background: 'linear-gradient(135deg, #13161D 0%, #1C2030 100%)',
        border: '0.5px solid rgba(245,130,10,0.2)',
        borderLeft: '3px solid #F5820A',
        borderRadius: 12, padding: '20px 24px', marginBottom: 24
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h1 style={{ fontFamily: 'Georgia, serif', fontSize: 24, color: '#F5820A', margin: 0 }}>
              Welcome to HoopsIQ
            </h1>
            <p style={{ fontFamily: 'sans-serif', fontSize: 13, color: '#8892A4', margin: '6px 0 0' }}>
              AI-powered NBA analytics — era normalization, GOAT analysis, and playoff simulation
            </p>
          </div>
          <div style={{ fontFamily: 'Courier New', fontSize: 10, color: '#8892A4', textAlign: 'right' }}>
            <div style={{ color: '#2ECC71', marginBottom: 4 }}>● All systems live</div>
            <div>/chat · /simulate · /era · /live</div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 12, marginTop: 16, flexWrap: 'wrap' }}>
          {STATS.map(s => (
            <div key={s.label} style={{
              background: 'rgba(255,255,255,0.04)',
              border: '0.5px solid rgba(255,255,255,0.08)',
              borderRadius: 8, padding: '8px 14px', textAlign: 'center'
            }}>
              <div style={{ fontFamily: 'Courier New', fontSize: 14, color: '#F0EDE6' }}>{s.val}</div>
              <div style={{ fontFamily: 'sans-serif', fontSize: 10, color: '#8892A4', marginTop: 2 }}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>

        {/* LEFT col */}
        <div>

          {/* Live Scores */}
          <div style={{
            background: '#13161D', border: '0.5px solid rgba(255,255,255,0.08)',
            borderRadius: 10, padding: 16, marginBottom: 16
          }}>
            <div style={{
              display: 'flex', justifyContent: 'space-between',
              alignItems: 'center', marginBottom: 14
            }}>
              <div style={{
                fontFamily: 'Courier New', fontSize: 9, color: '#8892A4',
                letterSpacing: '0.12em', textTransform: 'uppercase'
              }}>Today's Games {liveDate ? `— ${liveDate}` : ''}</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <div style={{
                  width: 6, height: 6, borderRadius: '50%',
                  background: liveLoading ? '#8892A4' : liveGames.length > 0 ? '#2ECC71' : '#F5820A',
                  animation: liveGames.length > 0 ? 'pulse 1.5s infinite' : 'none'
                }} />
                <span style={{ fontFamily: 'Courier New', fontSize: 9, color: '#8892A4' }}>
                  {liveLoading ? 'Loading...' : liveGames.length > 0 ? 'Live' : 'No games today'}
                </span>
              </div>
            </div>

            {liveLoading ? (
              <div style={{ fontFamily: 'sans-serif', fontSize: 12, color: '#8892A4', textAlign: 'center', padding: '12px 0' }}>
                Fetching scores...
              </div>
            ) : liveGames.length === 0 ? (
              <div style={{ fontFamily: 'sans-serif', fontSize: 12, color: '#8892A4', textAlign: 'center', padding: '12px 0' }}>
                No NBA games scheduled today.
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {liveGames.map((game: any, i: number) => {
                  const isLive = game.period > 0 && game.status && !game.status.includes('ET');
                  return (
                    <div key={i} style={{
                      background: '#1C2030',
                      border: `0.5px solid ${isLive ? 'rgba(46,204,113,0.3)' : 'rgba(255,255,255,0.06)'}`,
                      borderRadius: 8, padding: '10px 14px',
                      display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                    }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                          <span style={{ fontFamily: 'sans-serif', fontSize: 12 }}>{game.away_team}</span>
                          <span style={{ fontFamily: 'Courier New', fontSize: 14, fontWeight: 700 }}>{game.away_score}</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span style={{ fontFamily: 'sans-serif', fontSize: 12 }}>{game.home_team}</span>
                          <span style={{ fontFamily: 'Courier New', fontSize: 14, fontWeight: 700 }}>{game.home_score}</span>
                        </div>
                      </div>
                      <div style={{ marginLeft: 16, textAlign: 'center', minWidth: 60 }}>
                        {isLive ? (
                          <>
                            <div style={{ fontFamily: 'Courier New', fontSize: 9, color: '#2ECC71' }}>Q{game.period}</div>
                            <div style={{ fontFamily: 'Courier New', fontSize: 9, color: '#8892A4' }}>{game.clock}</div>
                          </>
                        ) : (
                          <div style={{ fontFamily: 'Courier New', fontSize: 9, color: '#8892A4' }}>{game.status}</div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* Featured Matchups */}
          <div style={{
            background: '#13161D', border: '0.5px solid rgba(255,255,255,0.08)',
            borderRadius: 10, padding: 16, marginBottom: 16
          }}>
            <div style={{
              fontFamily: 'Courier New', fontSize: 9, color: '#8892A4',
              letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 14
            }}>Featured Matchups</div>
            {FEATURED.map(f => {
              const key      = `${f.team1}-${f.team2}`;
              const result   = simResults[key];
              const isLoading = simLoading === key;
              return (
                <div key={key} style={{
                  background: '#1C2030', border: '0.5px solid rgba(255,255,255,0.06)',
                  borderRadius: 8, padding: '12px 14px', marginBottom: 8
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                    <div>
                      <span style={{ fontFamily: 'Georgia, serif', fontSize: 14 }}>{f.team1}</span>
                      <span style={{ fontFamily: 'Courier New', fontSize: 10, color: '#8892A4', margin: '0 8px' }}>vs</span>
                      <span style={{ fontFamily: 'Georgia, serif', fontSize: 14 }}>{f.team2}</span>
                    </div>
                    <span style={{ fontFamily: 'Courier New', fontSize: 9, color: '#8892A4' }}>{f.year}</span>
                  </div>
                  {result ? (
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                        <span style={{ fontFamily: 'Courier New', fontSize: 11, color: '#F5820A' }}>{result.toFixed(1)}%</span>
                        <span style={{ fontFamily: 'Courier New', fontSize: 11, color: '#7B8FD4' }}>{(100 - result).toFixed(1)}%</span>
                      </div>
                      <div style={{ height: 5, borderRadius: 3, display: 'flex', overflow: 'hidden' }}>
                        <div style={{ width: `${result}%`, background: '#F5820A', transition: 'width 0.6s ease' }} />
                        <div style={{ width: `${100 - result}%`, background: '#7B8FD4' }} />
                      </div>
                    </div>
                  ) : (
                    <button onClick={() => quickSim(f.team1, f.team2, key)}
                      disabled={!!simLoading} style={{
                        background: 'transparent',
                        border: '0.5px solid rgba(245,130,10,0.3)',
                        borderRadius: 6, padding: '4px 12px',
                        color: '#F5820A', fontFamily: 'Courier New',
                        fontSize: 9, letterSpacing: '0.08em',
                        textTransform: 'uppercase', cursor: 'pointer'
                      }}>
                      {isLoading ? 'Simulating...' : '▶ Simulate'}
                    </button>
                  )}
                </div>
              );
            })}
          </div>

          {/* Quick links */}
          <div style={{
            background: '#13161D', border: '0.5px solid rgba(255,255,255,0.08)',
            borderRadius: 10, padding: 16
          }}>
            <div style={{
              fontFamily: 'Courier New', fontSize: 9, color: '#8892A4',
              letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 12
            }}>Explore HoopsIQ</div>
            {[
              { label: 'Chat',           desc: 'Ask anything about NBA history',     color: '#F5820A' },
              { label: 'GOAT Mode',      desc: 'Compare the greatest players ever',  color: '#C9A84C' },
              { label: 'Simulate',       desc: 'Run 10,000 playoff simulations',     color: '#7B8FD4' },
              { label: 'Era Comparison', desc: 'Normalize stats across NBA eras',    color: '#2ECC71' },
            ].map(l => (
              <div key={l.label} style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '10px 0', borderBottom: '0.5px solid rgba(255,255,255,0.05)'
              }}>
                <div>
                  <div style={{ fontFamily: 'Georgia, serif', fontSize: 13, color: l.color }}>{l.label}</div>
                  <div style={{ fontFamily: 'sans-serif', fontSize: 11, color: '#8892A4', marginTop: 2 }}>{l.desc}</div>
                </div>
                <span style={{ color: '#8892A4', fontSize: 16 }}>›</span>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT col */}
        <div>
          {/* GOAT Leaderboard */}
          <div style={{
            background: '#13161D', border: '0.5px solid rgba(255,255,255,0.08)',
            borderRadius: 10, padding: 16
          }}>
            <div style={{
              fontFamily: 'Courier New', fontSize: 9, color: '#8892A4',
              letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 14
            }}>GOAT Leaderboard</div>
            {TOP_PLAYERS.map((p, i) => (
              <div key={p.name} style={{
                display: 'flex', alignItems: 'center', gap: 12,
                padding: '10px 0', borderBottom: '0.5px solid rgba(255,255,255,0.05)'
              }}>
                <div style={{
                  width: 24, height: 24, borderRadius: '50%',
                  background: i === 0 ? 'rgba(245,130,10,0.2)' : 'rgba(255,255,255,0.04)',
                  border: `0.5px solid ${i === 0 ? '#F5820A' : 'rgba(255,255,255,0.1)'}`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontFamily: 'Courier New', fontSize: 10,
                  color: i === 0 ? '#F5820A' : '#8892A4', flexShrink: 0
                }}>{i + 1}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                    <span style={{ fontFamily: 'Georgia, serif', fontSize: 13 }}>{p.name}</span>
                    <span style={{ fontFamily: 'Courier New', fontSize: 11, color: p.color }}>{p.goat}</span>
                  </div>
                  <div style={{ height: 3, background: 'rgba(255,255,255,0.06)', borderRadius: 2 }}>
                    <div style={{ height: '100%', width: `${p.goat}%`, background: p.color, borderRadius: 2 }} />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 3 }}>
                    <span style={{ fontFamily: 'Courier New', fontSize: 8, color: '#8892A4' }}>{p.pos}</span>
                    <span style={{ fontFamily: 'Courier New', fontSize: 8, color: '#8892A4' }}>{p.ppg} PPG</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* System Status */}
          <div style={{
            background: '#13161D', border: '0.5px solid rgba(255,255,255,0.08)',
            borderRadius: 10, padding: 16, marginTop: 16
          }}>
            <div style={{
              fontFamily: 'Courier New', fontSize: 9, color: '#8892A4',
              letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 12
            }}>System Status</div>
            {[
              { label: 'Bedrock (Claude Haiku)', route: '/chat'     },
              { label: 'Monte Carlo Engine',     route: '/simulate' },
              { label: 'Era Normalization',      route: '/era'      },
              { label: 'Live Scores',            route: '/live'     },
              { label: 'Player Database',        route: 'DynamoDB'  },
              { label: 'Amplify Hosting',        route: 'CDN'       },
              { label: 'Cognito Auth',           route: 'dqht7y'    },
            ].map(s => (
              <div key={s.label} style={{
                display: 'flex', justifyContent: 'space-between',
                alignItems: 'center', marginBottom: 8
              }}>
                <div>
                  <div style={{ fontFamily: 'sans-serif', fontSize: 12 }}>{s.label}</div>
                  <div style={{ fontFamily: 'Courier New', fontSize: 9, color: '#8892A4' }}>{s.route}</div>
                </div>
                <span style={{ fontFamily: 'Courier New', fontSize: 10, color: '#2ECC71' }}>● live</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.3} }
      `}</style>
    </div>
  );
};

export default Dashboard;